module.exports = __webpack_public_path__ + "static/1-d2f5d784e2f0bbe97620b316ee2407d1.jpeg";